import spritemap from "@milestone-sys/web-design-system/msds-spritemap.svg";
import "./row-action.scss";

interface DeleteRowActionProps {
    row;
    deleteClickHandler?: (row) => void;
    cameraGroupId?: number
}

// Create a cell renderer
export const DeleteRowAction = ({ row, deleteClickHandler, cameraGroupId }: DeleteRowActionProps) => {

    const id = cameraGroupId ?? row.original.id 

    return (
        <button id={"xsd__e2e-table-actions-deletion-row-" + row.index} className="row-action" type="button" onClick={() => deleteClickHandler(id)} title="Delete">
            <svg className="msds-icon">
                <use href={`${spritemap}#trash`} />
            </svg>
        </button>
    );
};
